<template>
  <detail v-if="inquiry" :key="inquiry.id" ref="d" :inquiry="inquiry" @reload="$emit('reload')" />
</template>

<script>
// Open a specific inquiry's detail by id from anywhere (a visitor's journey step,
// the latest-inquiries feed) — fetches the full inquiry, then shows the existing
// Detail dialog. Avoids the extra hop through the property's inquiry list.
import Detail from "@/components/inquiries/Detail";
import { Inquiry } from "@/graphql/queries/inquiries";

export default {
  components: { Detail },

  data: () => ({ inquiry: null, loading: false }),

  methods: {
    open(id) {
      if (!id || this.loading) return;
      this.loading = true;
      this.$apollo
        .query({ query: Inquiry, variables: { id: String(id) }, fetchPolicy: "no-cache" })
        .then(res => {
          this.inquiry = res.data.inquiry || null;
          // macrotask so the freshly-mounted drawer's click-outside handler can't
          // catch the click that triggered this open (see Card.openDetail)
          if (this.inquiry) setTimeout(() => { if (this.$refs.d) this.$refs.d.show = true; }, 0);
        })
        .finally(() => { this.loading = false; });
    }
  }
};
</script>
